import { SensorFilter, USAGE_STATUS } from "@shared/interfaces";
import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { SensorStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter: SensorFilter = {
  page: 0,
  limit: 50,
  search: "",
  usage_status: USAGE_STATUS.ALL,
};

export const initialState: SensorStateType = {
  sensors: [],
  sensorsTotal: 0,
  filter: { ...defaultFilter },
};

const reducer = createReducer<SensorStateType, Action>(initialState)
  .handleAction(actions.getSensors.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.sensors = !is_clear ? [...nextState.sensors, ...rows] : [...rows];
      nextState.sensorsTotal = count;
    }),
  )
  .handleAction(actions.createSensor.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.sensors = [action.payload.sensor, ...nextState.sensors];
    }),
  )
  .handleAction(actions.updateSensor.success, (state, action) =>
    produce(state, (nextState) => {
      const sensors = nextState.sensors;

      const foundSensorIndex = sensors.findIndex((s) => action.payload.sensor.id === s.id);
      sensors[foundSensorIndex] = action.payload.sensor;

      nextState.sensors = [...sensors];
    }),
  )
  .handleAction(actions.updateSensorStatus.success, (state, action) =>
    produce(state, (nextState) => {
      const sensors = nextState.sensors;

      const foundSensorIndex = sensors.findIndex((s) => action.payload.sensor.id === s.id);
      sensors[foundSensorIndex] = action.payload.sensor;

      nextState.sensors = [...sensors];
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.clearSensors, (state) =>
    produce(state, (nextState) => {
      nextState.sensors = [];
      nextState.sensorsTotal = 0;
    }),
  );

export { reducer as SensorReducer };
